export const setKeyResult = (keyResult) => ({
    type: "SET_KEY_RESULT",
    keyResult,
});
